
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { getInvestorAuth } from 'api/investor'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
CheckIcon,
PopupRadio
},
data () {
return {
localValidity: '存在有效期',
loading: true,
type: 0,
isThree: false,
check: true,
data: {
representativeName: '',
representativeSex: '',
representativeAge: '',
representativeDocumentsType: '身份证',
representativeIdCardNo: '',
representativeDocumentsValidity: '',
representativePosition: '',
representativeLanline: '',
representativeMobile: '',
representativeEmail: '',
representativeZip: '',
representativeAddress: ''
},
isIdCard: function (value) {
return {
valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
msg: '身份证号码格式不正确'
}
},
isPhone: function (value) {
return {
valid: /\d{1,20}/.test(value),
msg: '号码格式不正确'
}
},
valid: {
representativeName: false,
representativeSex: false,
representativeAge: false,
representativeDocumentsType: false,
representativeIdCardNo: false,
representativeDocumentsValidity: false,
representativePosition: false,
representativeLanline: false,
representativeMobile: false,
representativeEmail: false,
representativeZip: false,
representativeAddress: false
}
}
},
watch: {
localValidity: function (val, oldVal) {
if (val === '永久有效') {
this.data.representativeDocumentsValidity = val
} else {
this.data.representativeDocumentsValidity = ''
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_agency_update)
this.$_agency_init()
},
methods: {
$_agency_update () {
this.type = 1
this.check = false
},
$_agency_init () {
let _this = this
setTimeout(() => {
this.type = parseInt(this.$route.query.type)
if (this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
this.data = {
representativeName: res.representativeName,
representativeSex: res.representativeSex,
representativeAge: res.representativeAge,
representativeDocumentsType: res.representativeDocumentsType,
representativeIdCardNo: res.representativeIdCardNo,
representativeDocumentsValidity: res.representativeDocumentsValidity,
representativePosition: res.representativePosition,
representativeLanline: res.representativeLanline,
representativeMobile: res.representativeMobile,
representativeEmail: res.representativeEmail,
representativeZip: res.representativeZip,
representativeAddress: res.representativeAddress
}
}
this.loading = false
_this.$vux.loading.hide()
}, 500)
},
idcardChange (val) {
if (this.type === 1) {
if (val && val.length === 18) {
let year = parseInt(val.substring(6, 10))
let Year = new Date().getFullYear()
this.data.representativeAge = Year - year
let sex = parseInt(val.substr(16, 1))
this.data.representativeSex = sex % 2 === 0 ? '女' : '男'
}
}
},
$_agency_auth () {
if (this.type === 0) {
this.$_agency_next()
} else {
for (var item in this.valid) {
console.log(this.data[item])
if (this.data[item] === '') {
this.$vux.toast.show({type: 'warn', text: this.$refs[item].title + '为空或输入不合规范'})
return
}
}
this.$_handle_auth()
}
},
$_handle_auth () {
this.$vux.loading.show({text: '加载中'})
getInvestorAuth({userId: 0, name: this.data.representativeName, idcard: this.data.representativeIdCardNo}, this.$route.query.au).then((res) => {
console.log('而要素认证返回', res)
this.$vux.loading.hide()
if (res.code === 0) {
this.$_agency_next()
} else {
this.$vux.alert.show({
title: '提示',
content: res.msg
})
}
})
},
$_agency_next () {
this.$route.query.type = this.type
this.$route.query.isThree = this.isThree
this.$router.push({path: '/investor/agency/three', query: Object.assign(this.data, this.$route.query)})
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Agency/Two.vue